import { inject, Injectable } from "@angular/core";
import { GenericResponse } from "src/app/shared/interface/generic.interface";
import { Notification } from "../interface/notification.interface";
import { environment as env } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject, map, Observable, Subject } from "rxjs";
import { mapNotification } from "../helpers/mapNotification";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly _http = inject(HttpClient);
  readonly hasUnread$ = new BehaviorSubject<boolean>(false);
  readonly triggerShow$ = new Subject<void>();
  getNotifications(): Observable<GenericResponse<Notification[]>> {
    const requestUrl = env.api_url + "api/notificacion";
    return this._http.get<GenericResponse<Notification[]>>(requestUrl).pipe(
      map((response: GenericResponse<Notification[]>) => {
        const transformed = mapNotification(response)
        return transformed;
      })
    );
  }

  markNotificationsAsRead(notificationIds: number[]): Observable<any> {
    const requestUrl = env.api_url + `api/notificacion/mark-as-read`;
    return this._http.put<any>(requestUrl, { NotificationIds: notificationIds });
  }
}